import moment from 'moment'

export function formatHourWithLanguage(date, lang) {
  if (!date) return

  let format = null
  let formatType = null

  switch (lang) {
    case 'fr':
      format = '24hr'
      break
    case 'es':
      format = '24hr'
      break
    case 'en':
      format = 'ampm'
      break
    default:
      format = 'ampm'
  }

  if (format === '24hr') {
    formatType = 'HH:mm'
  } else {
    formatType = 'hh:mm A'
  }

  return moment.utc(date).local().format(formatType)
}

export function firstDayOfWeek(locale) {
  switch (locale) {
    case 'fr':
      return 1
    case 'en':
      return 0
    case 'es':
      return 1
    default:
      return 0
  }
}
